import MainNav from './MainNav'
export default MainNav



// WEBPACK FOOTER //
// ./src/organisms/Header/DesktopHeader/components/MainNav/index.js